export const TRADELINES_PROGRAM_STATUS = {
    "Opening New Tradeline": { name: "Opening New Tradeline", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Reporting to Credit Bureaus": { name: "Reporting to Credit Bureaus", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Adding Authorized Users": { name: "Adding Authorized Users", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Closing a Tradeline": { name: "Closing a Tradeline", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Removing Authorized Users": { name: "Removing Authorized Users", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Canceled": { name: "Canceled", color: "!bg-color11", open: false, bgColor: 'color11' },
    "Completed": { name: "Completed", color: "!bg-color9", open: false, bgColor: 'color9' }
};

export const MORTGAGE_PROGRAM_STATUS = {
    "Initial Consultation": { name: "Initial Consultation", color: "!bg-color15 !text-color7", open: true, bgColor: 'color15' },
    "Pre-Approved": { name: "Pre-Approved", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Loan Application": { name: "Loan Application", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Document Collection and Verification": { name: "Document Collection and Verification", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Loan Processing": { name: "Loan Processing", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Underwriting": { name: "Underwriting", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Appraisal": { name: "Appraisal", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Loan Approval": { name: "Loan Approval", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Rate Lock": { name: "Rate Lock", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Closing Disclosure": { name: "Closing Disclosure", color: "!bg-color9", open: true, bgColor: 'color9' },
    "Closing": { name: "Closing", color: "!bg-color9", open: true, bgColor: 'color9' },
    "Post-Closing ": { name: "Post-Closing ", color: "!bg-color9", open: false, bgColor: 'color9' },
    "Completed": { name: "Completed", color: "!bg-color9", open: false, bgColor: 'color9' },
    "Canceled": { name: "Canceled", color: "!bg-color11", open: false, bgColor: 'color11' }
};

export const REFINANCING_PROGRAM_STATUS = {
    "Initial Consultation": { name: "Initial Consultation", color: "!bg-color15 !text-color7", open: true, bgColor: 'color15' },
    "Pre-Approved": { name: "Pre-Approved", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Application Submission": { name: "Application Submission", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Document Collection and Verification": { name: "Document Collection and Verification", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Loan Estimate Review": { name: "Loan Estimate Review", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Appraisal": { name: "Appraisal", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Approval and Underwriting": { name: "Approval and Underwriting", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Rate Lock": { name: "Rate Lock", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Closing Preparation": { name: "Closing Preparation", color: "!bg-color9", open: true, bgColor: 'color9' },
    "Signing and Closing": { name: "Signing and Closing", color: "!bg-color9", open: true, bgColor: 'color9' },
    "Post-Closing": { name: "Post-Closing", color: "!bg-color9", open: false, bgColor: 'color9' },
    "Completed": { name: "Completed", color: "!bg-color9", open: false, bgColor: 'color9' },
    "Canceled": { name: "Canceled", color: "!bg-color11", open: false, bgColor: 'color11' }
};

export const SELLER_PROGRAM_STATUS = {
    "Initial Consultation": { name: "Initial Consultation", color: "!bg-color15 !text-color7", open: true, bgColor: 'color15' },
    "Property Preparation": { name: "Property Preparation", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Property Listed": { name: "Property Listed", color: "!bg-color14", open: true, bgColor: 'color14' },
    "Offer Review and Negotiation": { name: "Offer Review and Negotiation", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Offer Accepted": { name: "Offer Accepted", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Inspection and Due Diligence": { name: "Inspection and Due Diligence", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Appraisal and Financing": { name: "Appraisal and Financing", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Closing Preparation": { name: "Closing Preparation", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Closing": { name: "Closing", color: "!bg-color9", open: true, bgColor: 'color9' },
    "Completed": { name: "Completed", color: "!bg-color9", open: false, bgColor: 'color9' },
    "Canceled": { name: "Canceled", color: "!bg-color11", open: false, bgColor: 'color11' }
};

export const BUYER_PROGRAM_STATUS = {
    // Statuses for new buyer steps
    "Open Escrow": { name: "Open Escrow", color: "!bg-color15 !text-color7", open: true, bgColor: 'color15' },
    "Buyer's Deposit": { name: "Buyer's Deposit", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Review of Seller Disclousures": { name: "Review of Seller Disclousures", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Inspections Contingency": { name: "Inspections Contingency", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Appraisal Contingecy": { name: "Appraisal Contingecy", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Release Loan Contingency": { name: "Release Loan Contingency", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Clear to Close (CTC)": { name: "Clear to Close (CTC)", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Closing Disclosure (CD)": { name: "Closing Disclosure (CD)", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
    "Closing Date": { name: "Closing Date", color: "!bg-color2 !text-color7", open: true, bgColor: 'color2' },
};


export const RE_PROGRAMS = [
    "Seller",
    "Buyer",
    "Mortgage",
    "Refinancing",
];

export const NO_TABS_PROGRAMS = [
    ...RE_PROGRAMS,
    "Taxes",
    "Corporations",
    "Book Keeping",
]

export const REFINANCING_PROGRAM_TYPES = [
    "Hard Money",
    "Reverse",
    "PNL ONLY",
    "HELOC",
    "Conventional",
    "FHA",
    "DSDR",
    "Reversible Mortgage",
    "Commercial",
]

export const RE_PROGRAM_COMMISSIONS_STATUS = [
    "Paid",
    "Pending Broker",
    "Pending Escrow",
    "Pending Lender",
    "N/A"
]

export const RE_PROGRAM_DP_STATUS = [
    "Pending Lender",
    "Pending Next Layer",
    "Pending Broker",
]